module.exports = __webpack_public_path__ + "static/media/3DPPA4.eb3a074d.jpg";